import {EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {FieldValue} from '../../../form-renderer/interfaces/FieldValue';
import {AbstractControl, FormGroup} from '@angular/forms';
import {StringUtilities} from '../../../utilities/StringUtilities';
import {FieldEditedEvent} from '../../../form-renderer/interfaces/FieldEditedEvent';


export abstract class FieldComponentAbstract {
  /**
   * If false then the field will override the readonly attribute to make the field not editable.
   * If the field is readonly and editable is true then the field will still be readonly
   * @type {boolean}
   */
  @Input() editable = true;
  public completed = false;
  private _fieldValue: FieldValue;
  @Input() public form: FormGroup;
  @Output() public fieldValueChange = new EventEmitter();
  @Output() public edited = new EventEmitter<FieldEditedEvent>();
  @HostBinding('class.not-required') public get isNotRequired(): boolean {
    if (!this._fieldValue)
      return false;
    return this._fieldValue.field.required === false;
  }

  /**
   * Get the field value for two way binding
   * @returns {FieldValue}
   */
  @Input()
  get fieldValue() {
    return this._fieldValue;
  }

  // set the field value for two way binding
  set fieldValue(val) {
    this._fieldValue = val;
    this.fieldValueChange.emit(this._fieldValue);
  }

  getControl(): AbstractControl {
    return this.form.controls[this.getKey()];
  }

  getControlValue<T = any>(): T {
    const control = this.getControl();
    return control ? <T>this.getControl().value : null;
  }

  onChange(data: FieldValue) {
    this.edited.emit({field: data || this._fieldValue});
  }

  getKey() {
    return StringUtilities.camelize(this._fieldValue.field.name);
  }

  isValid() {
    return this.form.get(this.getKey()).valid
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/components/abstracts/FieldComponentAbstract.ts